import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import classnames from 'classnames';

import Icon from './Icon';
import BaseModal from './BaseModal';
import FormattedHTMLMessage from './FormattedHTMLMessage';

function HelpModal ({ className, icon, heading, message, centerMessage, children, moreInfoText, onClose, show, onOpen }) {
    const messageClass = classnames({ 'text-center': centerMessage });
    return (
        <BaseModal
            show={ show }
            onClose={ onClose }
            onOpen={ onOpen }
            className={classnames("modal-help", className)}
            titleText={ heading }
            hideContinue
        >
                <section className="text-center">
                    { !children && <Icon icon={ `${icon} margin-top margin-bottom otrl-xl` } /> }
                    <div className="text-left">
                        { children ||
                            <FormattedHTMLMessage
                                splitParagraphs
                                tagName="p"
                                message={ message }
                                className={ messageClass }
                            />
                        }
                        { moreInfoText && <p>{ moreInfoText }</p> }
                    </div>
                </section>
        </BaseModal>
    );
}

HelpModal.propTypes = {
    show: PropTypes.bool,
    icon: PropTypes.string,
    heading: PropTypes.string.isRequired,
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
    message: PropTypes.string,
    centerMessage: PropTypes.bool,
    moreInfoText: PropTypes.element,
    children: PropTypes.element,
    className: PropTypes.string,
    checkProps (props, propName, componentName) {
        if (!props.message && !props.children) {
            throw new Error(`Missing prop 'message' or 'children' for ${componentName}`);
        }
    }
};

HelpModal.defaultProps = {
    show: false,
    icon: 'success',
    heading: 'info.title',
    onClose: _.noop,
    onOpen: _.noop,
    centerMessage: false,
    className: 'modal--sm'
};

export default HelpModal;



// WEBPACK FOOTER //
// ./src/components/general/HelpModal.js